import type { GraphQLErrors } from "@apollo/client/errors";
import type { GenqlError as GenqlErrorMagento } from "~/graphql/genql/magento";
import type { GenqlError as GenqlErrorPim } from "~/graphql/genql/pim";

export function logError(props: {
	error: Error | GraphQLErrors | GenqlErrorMagento | GenqlErrorPim;
	digest?: string;
	tags: Record<string, string>;
}) {
	console.error(props.error);

	if (props.digest) {
		console.info("digest", props.digest);
	}
}
